import Navbar from './components/Navbar';
import Profile from './components/Profile';
import Projects from './components/Projects';
import About from './components/About';
import Skills from './components/Skills';
import Contact from './components/Contact';
import './App.css';

function App() {
  return (
    <div className="app">
      <Navbar />
      <main>
        <section id="home" className="section-home">
          <Profile />
        </section>
        
        <About />
        
        <Skills />
        
        <section id="projects" className="section-projects">
          <Projects />
        </section>
        
        <Contact />
      </main>
      
      {/* Scroll to top button - will add functionality later */}
      <button 
        className="scroll-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Scroll to top"
      >
        ↑
      </button>
    </div>
  );
}

export default App;